<template>
  <div class="block-clock-container" :class="[device_platform]">
    <div class="clock-wrapper">
      <p class="clock__title">До конца акции</p>
      <div class="bclock-clock">
        <template v-for="(stat, index) in date_parts">
          <div class="clock__stats" :key="index">
            <div class="clock__value-container">
              <div class="clock__value no-select">
                {{ timeElement(stat)[0] }}
              </div>
              <div class="clock__value no-select">
                {{ timeElement(stat)[1] }}
              </div>
            </div>
            <div class="clock__name no-select">
              {{ stat.name }}
            </div>
          </div>
          <div
            v-if="!stat.units.includes('seconds')"
            class="clock__separator"
            :key="stat.units"
          ></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from "../common/mixin";
import CF from "../common/common-functions";

export default {
  name: "clock",
  props: ["date"],
  mixins: [Mixin],
  props: [""],
  data() {
    return {
      date_parts: [
        {
          name: "Дней",
          units: "days",
          value: 0,
          period: 0,
        },
        {
          name: "Часов",
          units: "hours",
          value: 0,
          period: 24,
        },
        {
          name: "Минут",
          units: "minutes",
          value: 0,
          period: 60,
        },
        {
          name: "Секунд",
          units: "seconds",
          value: 0,
          period: 60,
        },
      ],
    };
  },
  mounted() {
    let small_part_multiplier = 1,
      time_left = (this.CONSTANTS.end_date.getTime() - Date.now()) / 1000;
    for (let i = this.date_parts.length - 1; i >= 0; --i) {
      let part = this.date_parts[i];
      part.value = Math.floor(
        (time_left / small_part_multiplier) % (part.period || 10000)
      );
      part.name = this.getName(part);
      small_part_multiplier = small_part_multiplier * part.period;
    }
    setInterval(this.clockTick, 1000);
  },
  methods: {
    clockTick() {
      for (let i = this.date_parts.length - 1; i >= 0; --i) {
        if (this.date_parts[i].value > 0) {
          --this.date_parts[i].value;
          this.date_parts[i].name = this.getName(this.date_parts[i]);
          return;
        }
        this.date_parts[i].value = this.date_parts[i].period - 1;
        this.date_parts[i].name = this.getName(this.date_parts[i]);
      }
    },
    getName(date_part) {
      return CF.getNumericalName(date_part.value, date_part.units);
    },
    timeElement(stat) {
      let time = stat.value.toString();
      if (time.length < 2) {
        time = "0" + time;
      }
      return time;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.block-clock-container {
}

.clock-wrapper {
}

.bclock-clock {
  display: flex;
}

.clock {
  &__title {
    font-size: calcFontSize(14, 18, 320, 1440);
    color: $transparent-gray;
    margin-bottom: 15px;
  }

  &__value-container {
    display: flex;
    justify-content: center;
  }

  &__value {
    width: calcFontSize(27, 41, 320, 1440);
    text-align: center;
    line-height: 1.8em;
    font-family: "Bebas Neue", sans-serif;
    font-size: calcFontSize(18, 32, 320, 1440);
    font-weight: 400;
    background-color: $almost-transparent;
    color: $almost-gray;

    &:nth-child(odd) {
      margin-right: 4px;
    }
  }

  &__name {
    font-size: calcFontSize(12, 16, 320, 1440);
    text-align: center;
    color: $transparent-gray;
    margin: 8px;
  }

  &__separator {
    margin: 0 4px;
  }
}

@media (max-width: 640px) {
  .clock {
    &__title {
      text-align: center;
    }
  }
}
</style>
